export const generatePageNumbers = (
  currentPage: number,
  totalPages: number,
) => {
  // The maximum number of page numbers to display
  const maxPageNumbers = 7

  // Calculate the number of page numbers to show before and after the current page
  let numbersToShow = Math.min(maxPageNumbers, totalPages)
  let beforeCurrentPage = Math.floor(numbersToShow / 2)
  let afterCurrentPage = numbersToShow - beforeCurrentPage - 1

  // Adjust if the current page is near the start or end
  if (currentPage - beforeCurrentPage < 1) {
    afterCurrentPage += beforeCurrentPage - (currentPage - 1)
    beforeCurrentPage = currentPage - 1
  }
  if (currentPage + afterCurrentPage > totalPages) {
    beforeCurrentPage += afterCurrentPage - (totalPages - currentPage)
    afterCurrentPage = totalPages - currentPage
  }

  // Generate the array of page numbers
  let pageNumbers = []
  for (
    let i = currentPage - beforeCurrentPage;
    i <= currentPage + afterCurrentPage;
    i++
  ) {
    pageNumbers.push(i)
  }

  return pageNumbers
}
